module.exports = __webpack_public_path__ + "static/media/injetora.1fd482ab.png";